import styled from 'styled-components'

export const ResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ChoicesContainer = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 20px;
`

export const ChoiceItem = styled.div`
  text-align: center;
  color: #ffffff;
`

export const ChoiceImage = styled.img`
  width: 120px;

  @media screen and (min-width: 768px) {
    width: 150px;
  }
`

export const ResultText = styled.p`
  color: #ffffff;
  font-family: 'Bree Serif';
  font-size: 22px;
  margin: 10px 0;

  @media screen and (min-width: 768px) {
    font-size: 28px;
  }
`

export const PlayAgainButton = styled.button`
  background-color: #ffffff;
  color: #223a5f;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-family: 'Bree Serif';
  cursor: pointer;
  font-size: 14px;

  @media screen and (min-width: 768px) {
    font-size: 18px;
    padding: 12px 28px;
  }
`
